import { CISelect } from 'car-insurance/components/common/CISelect';
import classNames from 'classnames';
import React from 'react';

interface FormSelectProps {
  options: { value: string; label: string }[];
  label?: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  selectContainerClass?: string;
  error?: string;
  search?: boolean;
}

export const FormSelect: React.FC<FormSelectProps> = ({
  options,
  value,
  label,
  onChange,
  disabled = false,
  placeholder = '',
  error,
  search = false,
}) => {
  return (
    <div className="flex flex-col gap-1 w-full">
      {!!label && (
        <p className="text-gray-800 font-medium text-base leading-4">{label}</p>
      )}
      <div className="w-full h-9">
        <CISelect
          search={search}
          options={options}
          border={true}
          value={value}
          onChange={onChange}
          disabled={disabled}
          containerClassName={classNames('sm:!px-2.5 !rounded-lg', {
            '!border-[#E57373]': Boolean(error),
          })}
          dropdownClassName={disabled ? '!text-[#BDBDBD]' : '!text-gray-900'}
          placeholder={placeholder}
          labelClassName="!text-base !font-semibold truncate max-w-[90%]"
          disabledClassName="!cursor-default pointer-events-none !bg-[#F5F5F5]"
          key={`${JSON.stringify(options)}-${value}`}
        />
      </div>
      {!!error && <p className="font-normal text-sm text-red-800">{error}</p>}
    </div>
  );
};
